export const BUTTON_TYPE = {
  default: 'default',
  loading: 'loading',
  start: 'start',
};

export const CAPTCHA_TYPE = {
  imgCode: 1,
  captcha: 2, // 滑块，支持降级
  pureCaptcha: 3,
};

// 点击按钮的触发类型
export const TRIGGER_TYPE = {
  getCode: 'getCode', // 获取验证码
  submit: 'submit', // 登录/注册
};

export const REGISTRATION_TYPE = {
  phone: 'phoneRegistration',
  email: 'emailRegistration',
};

export const DEFAULT_REGISTER_TYPE = {
  phone: 1,
  email: 2,
};

export const LOGIN_TYPE = {
  account: 'account',
  sms: 'sms',
  qrcode: 'qrcode',
  mobileLoginAndRegister: 'mobileLoginAndRegister',
};

export const DEFAULT_LOGIN_TYPE = {
  account: 0,
  sms: 1,
  qrcode: 2,
  mobileLoginAndRegister: 3,
};

export const ERROR_CODE = {
  // 操作频繁
  // 发送验证码频繁
  frequent: [
    'IDC-02-00038',
    'IDC-02-00064',
    'IDC-02-00211',
    'IDC-02-00212',
    'IDC-02-00213',
    'IDC-02-00215',
    'IDC-02-00228',
  ],
  // 多次错误，账号将锁定
  accountLock: ['IDC-04-0003', 'IDC-02-0013', 'IDC-03-00048', 'IDC-01-00034'],
  // 账号已锁定倒计时
  accountLocked: ['IDC-02-0004'],
  // 安全风险倒计时
  operationRisk: ['IDC-02-00214'],

  // 需要更多操作
  // 风控
  riskControl: ['IDC-03-00059', 'IDC-02-0021'],
  // 多账号
  multiAccounts: ['IDC-03-00009'],
  // 系统内部错误
  internalError: ['IDC-10-00500', 'IDC-02-00165'],

  // 操作错误
  // 表单数据错误
  formData: ['IDC-02-00227', 'IDC-02-00224', 'IDC-02-00226'],
  // 图形验证码错误
  imgCode: ['IDC-03-0002', 'IDC-00-0004'],
  // 安全风险
  securityRisks: ['IDC-03-0003'],
  // 短信验证码错误
  smsCode: ['IDC-02-00029'],
};

export const ACCEPT_PUSH_MSG = {
  // 不接受
  notAccept: 0,
  // 接受
  accept: 1,
  // 用户未确认
  notConfirm: 2,
};

export const AGREEMENT = {
  yes: 'yes',
  no: 'no',
};

export const MOBILE_WIDTH = 768;

export const CONTEXT = {
  uniportal: '/uniportal1',
  account: '/accounts1',
};
